import { Card, Stack, Typography, Switch, ToggleButtonGroup, ToggleButton, Button } from "@mui/material";
import { TRAFFIC_TYPES } from "Constants/Stations";

import { SHOW_TYPES } from "Constants/Survey";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import {
  toggleVisibility as toggleTraffics,
  togglePointwiseShow,
  changeTrafficType,
  changeTrafficShowType,
} from "Redux/trafficSlice";
import {
  SelectingType,
  ColorStepType,
  changeHeatMap2ColorStep,
  toggleShowHeatMap2Numbers,
  changeApplySelected,
} from "Redux/trafficZoneSlices";
import MenuButton from "./Button";

export default function Traffic() {
  const dispatch = useAppDispatch();

  const { trafficShowType, visible, pointwiseShow, trafficTypes } = useAppSelector((state) => state.traffic);
  const { colorStep, showHeatMap2Numbers } = useAppSelector((state) => state.trafficZones);

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleSurveyShowType = (event: React.MouseEvent<HTMLElement>, newMode: SelectingType) => {
    if (newMode !== null) {
      dispatch(changeTrafficShowType(Number(newMode)));
    }
  };

  const SPECTRUM_NUMBERS = [1200, 800, 400, 240, 120];

  const handleShowHeatMap2Numbers = () => {
    dispatch(toggleShowHeatMap2Numbers());
  };

  const handleMarkerPointWise = () => {
    dispatch(togglePointwiseShow());
  };

  const handleheatMap2Step = (event: React.MouseEvent<HTMLElement>, step: ColorStepType) => {
    if (step !== null) {
      dispatch(changeHeatMap2ColorStep(step));
    }
  };

  const handleSwitch = () => {
    dispatch(toggleTraffics());
    dispatch(changeApplySelected(false));
  };

  const handleClick = (key: string) => {
    dispatch(changeTrafficType(key));
  };

  const handleOptions = () => {
    if (trafficShowType === 0) {
      return (
        <Button onClick={handleMarkerPointWise} variant={pointwiseShow ? "contained" : "light"} style={{ marginRight: "10px" }}>
          نمایش نقطه ای
        </Button>
      );
    }
    if (trafficShowType === 2) {
      return (
        <Stack direction="row">
          <Stack direction="row" sx={{ justifyContent: "space-between" }}>
            <Button onClick={handleShowHeatMap2Numbers} variant={showHeatMap2Numbers ? "contained" : "light"} sx={{ mx: "10px" }}>
              نمایش اعداد
            </Button>
          </Stack>
          <Stack>
            <ToggleButtonGroup value={colorStep} exclusive onChange={handleheatMap2Step} aria-label="text alignment">
              {SPECTRUM_NUMBERS.map((s, index) => (
                <ToggleButton
                  className="fa-number"
                  value={index + 1}
                  aria-label={`top-${s}`}
                  style={{
                    width: "56px",
                    height: "56px",
                    backgroundColor: colorStep === index + 1 ? "#4754CA" : "",
                    color: colorStep === index + 1 ? "#fff" : "",
                  }}
                >
                  طیف {s}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Stack>
        </Stack>
      );
    }
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack direction="row" spacing={2} sx={{ justifyContent: "space-between" }}>
        {TRAFFIC_TYPES.map((item) => (
          <MenuButton isActive={trafficTypes.includes(item.type)} onClick={() => handleClick(item.type)} title={item.text}>
            {!trafficTypes.includes(item.type) ? (
              <img src={item.imgSrc} alt="test" style={{ width: "28px" }} />
            ) : (
              <img src={item.whiteImgSrc} alt="test" style={{ width: "28px" }} />
            )}
          </MenuButton>
        ))}
        {handleOptions()}
        <ToggleButtonGroup
          value={Number(trafficShowType)}
          onChange={handleSurveyShowType}
          exclusive
          aria-label="traffic-show-type"
        >
          {SHOW_TYPES.map((t, index) => (
            <ToggleButton
              value={index}
              aria-label={`traffic-mode-${index}`}
              style={{
                width: "80px",
                height: "56px",
                backgroundColor: Number(trafficShowType) === index ? "#4754CA" : "",
                color: Number(trafficShowType) === index ? "#fff" : "",
              }}
            >
              {t}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={handleSwitch} checked={visible} />
        </Stack>
      </Stack>
    </Card>
  );
}
